import React, { useState } from "react";
import HelloText from "../components/HelloText";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { Button } from "@mui/material";
const MedicalAdd = () => {
  const [link, setLink] = useState();
  const [name, setName] = useState();
  const [language, setLanguage] = useState();
  const [katalog, setKatalog] = useState();
  const [Image, setImage] = useState();
  const [tag, setTag] = useState();
  const [description, setDescription] = useState();
  const avatarHandle = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.addEventListener("load", function () {
      setImage(this.result);
    });
    reader.readAsDataURL(file);
  };
  return (
    <>
      <HelloText />
      <Box
        component="form"
        method="post"
        action={process.env.REACT_APP_DEF_URL + "medicaladd"}
        sx={{
          "& > :not(style)": {
            m: 1,
            width: "80%",
            display: "flex",
            alignItems: "center",
          },
        }}
        noValidate
        autoComplete="off"
        encType="multipart/form-data"
      >
        <TextField
          id="outlined-basic"
          label="Başlık"
          variant={"outlined"}
          fullWidth
          name="medical_title"
          onChange={(e) => setName(e.target.value)}
          value={name}
        />
        <TextField
          id="outlined-basic"
          label="Alt Başlık"
          variant={"outlined"}
          fullWidth
          name="medical_subtitle"
          onChange={(e) => setKatalog(e.target.value)}
          value={katalog}
        />

        <label for="lang">Dil:</label>
        <select
          name="medical_language"
          id="lang"
          value={language}
          onChange={(e) => setLanguage(e.target.value)}
        >
          <option value="tr-TR">tr</option>
          <option value="en-gb">en</option>
        </select>
        {Image ? (
          <img
            id="blah"
            src={Image}
            alt="your image"
            style={{ maxHeight: "300px", objectFit: "contain" }}
          />
        ) : (
          ""
        )}
        <Button variant="contained" component="label">
          Resim yükle
          <input
            hidden
            accept="image/*"
            multiple
            type="file"
            name="medical_image"
            onChange={avatarHandle}
          />
        </Button>
        <p>Meta Description</p>
        <TextField
          id="outlined-basics"
          label="tags"
          variant={"outlined"}
          fullWidth
          name="medical_keywords"
          onChange={(e) => setTag(e.target.value)}
          value={tag}
        />
        <TextField
          id="outlined-basics"
          label="description"
          variant={"outlined"}
          fullWidth
          multiline
          minRows={3}
          maxRows={8}
          name="medical_description"
          onChange={(e) => setDescription(e.target.value)}
          value={description}
        />
        <Button variant="outlined" type="submit">
          Ekle
        </Button>
      </Box>
    </>
  );
};

export default MedicalAdd;
